import { Component } from 'vue-property-decorator';
import { ItiBaseModal, ItiToolbarOkCancel, ItiScheduledTask } from '@/iti-core-vuetify';
import { ItiString } from '@/iti-core-vue';
import itiScheduledTasksModule from '@/store/modules/iti-scheduled-tasks.module';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

@Component({
    components: {
        ValidationObserver,
        ValidationProvider,
        ItiToolbarOkCancel,
    },
})
export default class ItiScheduledTaskForm extends ItiBaseModal {

    public get task(): ItiScheduledTask {
        return itiScheduledTasksModule.task;
    }
    public set task(newValue: ItiScheduledTask) {
        itiScheduledTasksModule.setTask(newValue);
    }

    // Cuando esté disponible en el API habría que cargar la lista de jobs disponibles desde el API
    public itemsTasksTypes = [
        'MarcarComoErrorPrediccionesAntiguas', 'tipo 2', 'tipo 3', 'tipo 4',
    ];

    public horas = 24;

    public mounted() {
        if (!ItiString.IsNullOrWhiteSpace(this.task.Cron)) {
            // 0 0/5 0/X ? * * *
            const items = this.task.Cron.split(' ');
            if (items.length > 3) {
                // 0/X
                const subitems = items[2].split('/');
                if (subitems.length > 1) {
                    this.horas = Number(subitems[1]);
                }
            }
        }
    }

    public async submit() {
        const allOk = await this.validate();
        if (allOk) {
            this.composeCron();
            await itiScheduledTasksModule.saveTask();
            this.closeModal();
        }
    }

    public cancel() {
        this.closeModal();
    }

    protected composeCron() {
        this.task.Cron = ItiString.Format('0 0/5 0/{0} ? * * *', this.horas);
    }
}
